// import bg from '../../assets/pinstripe-background.svg';

export const Screen = ({ children }) => <div
  className='w-screen min-h-screen flex justify-center items-center bg-neutral-100 bg-repeat'
  style={{
    // backgroundImage: `url(${bg})`,
  }}
>
  {children}
</div >;